if(window.location.pathname === '/pages/customer-information' || window.location.pathname === '/account/register') {
  let counter = 0;
  let selector = "#city-field"
  const interval = setInterval(() => {
      let element = document.querySelector(selector);
      if (element) {
          handleForm();
          clearInterval(interval);
      } else {
          counter += 100;
          if (counter >= 10000) {
              clearInterval(interval);
          }
      }
  }, 100);
}

function handleForm(){
  const target = document.querySelector(`.bss-b2b-rf-field:has([title="HOW MANY ADDITIONAL LOCATIONS YOU HAVE (IF ANY)"])`);
  if(target) {
    target.insertAdjacentHTML("beforeBegin", `<div class="bss-b2b-rf-field field-select bss-b2b-grid-col-3"><hr></div>`);
  }

  // handle input
  document.querySelector(`[type="file"]`).addEventListener("change", function () {
    const fileDisplay = document.getElementById("fileName");

    if (this.files.length === 0) {
        fileDisplay.textContent = "No file selected";
    } else {
        const names = Array.from(this.files).map(file => file.name);
        fileDisplay.textContent = names.join(", ");
    }
  });

  const upload = document.querySelector(`[type="file"]`);
  upload.insertAdjacentHTML("afterEnd", `<div class="upload-box">
    <label for="fileUpload" class="upload-btn">Upload All Licenses Here</label>
      <p id="fileName">No file selected</p>
  </div>`);

  const title = document.querySelector(".bss-b2b-registration-form-title h1");
  if(title) {
    title.innerText = "CREATE AN ACCOUNT";
    title.insertAdjacentHTML("afterEnd", `<hr><p>Already have an account? <a href="https://www.kootenaycultivar.ca/account/login">LOGIN HERE.</a></p>`)
  }

  // custom show address
  let indexFirstAdrress = 0;
  document.querySelectorAll(".bss-b2b-rf-field").forEach((item, index) => {
    if(item.querySelector("#text-field-ba3314875978f")) {
        indexFirstAdrress = index - 1;
      }
  })
  const listAdress = document.querySelectorAll(".bss-b2b-rf-field");
  if(listAdress?.length) {
      listAdress.forEach((item, index) => {
          if(index > indexFirstAdrress && index < (51 + indexFirstAdrress)) item.style.display = 'none';
      })
  }
  const selectCountAdress = document.querySelector("#select-group-d3e2558c92da2");
  selectCountAdress.addEventListener("change", e => {
      const count = selectCountAdress.value;
      if(listAdress?.length) {
          listAdress.forEach((item, index) => {
              if(index > indexFirstAdrress && index < (51 + indexFirstAdrress)) item.style.display = 'none';
          })
      }
      if(listAdress?.length) {
          listAdress.forEach((item, index) => {
              if(index > indexFirstAdrress && index < (indexFirstAdrress + count * 5)) item.style.display = 'block';
          })
      }
  })
}

const style = document.createElement('style');
style.textContent = `.page__title.h2 {
    display: none;
} 

#bss-b2b-registration-form {
box-shadow: unset !important;
} 

input, select {
border-radius: 0 !important;
}

#country-list li, #phone-country-list li {
    margin: 0 !important;
}
input:focus, select:focus, input:hover, select:hover{
    box-shadow: unset !important;
    border-color: #000 !important;
}  

.bss-b2b-rf-accept-marketing {
    gap: 10px;
}

.field-state {
display: block !important;
}
#state-field:not(:has(option)) {
pointer-events: none !important;
}
input.btn {
    max-width: 200px;
    background: green !important;
}
hr {
    width: 30%;
    margin: 10px auto;
    border-color: #747474;
}
@media screen and (min-width: 1500px) {
#bss-b2b-register-form {
    width: 800px !important;
}
}

input[type='file'] {
    opacity: 0;
    height: 46px;
    z-index: 999;
    width: 100%;
    top: 25px;
    position: absolute;
}

.upload-box {
   width: 100%;
    text-align: center;
    margin-top: 0px;
    font-family: Arial, sans-serif;
}

.upload-btn {
    display: inline-block;
    padding: 10px 20px;
    background-color: #ffff;
    border: 1px solid #ccc;
    cursor: pointer;
    margin-bottom: 8px;
}

.upload-btn:hover {
    background-color: #dcdcdc;
}

#fileName {
    font-size: 14px;
    color: #555;
    margin: -12px;
}

#bss-b2b-register-form h1 {
    width: 100%;
    font-weight: 600;
    font-size: 26px !important;
}
.bss-b2b-registration-form-title h1 {
    font-size: 3.2075rem !important;
    font-weight: 600;
    display: flex;
    justify-content: center;
    align-items: center;
    white-space: nowrap;
}`;
document.head.appendChild(style);